import { useMutation, useQueryClient } from "@tanstack/react-query"
import { bulkUpdateDealStage } from "@/api"

export const useBulkUpdateDealStage = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ dealIds, stageId }: { dealIds: number[]; stageId: number }) =>
      bulkUpdateDealStage(dealIds, stageId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["dealPipeline"] })
    },
  })
}
